import React, { createContext, useContext } from 'react';
import { UnsavedChangesConfirmationModal } from '~/Components';
import { useBlockNavigation } from './useBlockNavigation';

export type NavigationContextType = ReturnType<typeof useBlockNavigation>;

const NavigationContext = createContext<NavigationContextType>({} as NavigationContextType);

export const NavigationContextWrapper = ({ children }: { children: React.ReactNode }) => {
  const store = useBlockNavigation();

  return (
    <NavigationContext.Provider value={store}>
      {children}
      <UnsavedChangesConfirmationModal />
    </NavigationContext.Provider>
  );
};

export const useNavigationContext = () => useContext(NavigationContext);
